import { systemCodeService } from '@/services';
export default {
    async getBankCode({ commit }) {
        const response = await systemCodeService.getBankCode();
        commit('SET_BANK_CODE', response.data);
    },
    async getInsuranceCode() {
        const response = await systemCodeService.getInsuranceCode();
        return response.data;
    },
};
